import React, { useCallback, useEffect, useState } from "react";
import Cookies from "universal-cookie";
import { cookiesKeyNames } from "@revbox/common-fe";
import { getPubAbbr } from "@revbox/helpers-fe";
import { topicClusterLabels } from "@revbox/localization";
import { TaxonomyModule } from "../../../../../modules/taxonomy";
import { getPathKey, useCookiesContext } from "../../../../../contexts/CookiesContext";

export function ClusterNameRenderer({ node, value }) {
    const [expanded, setExpanded] = useState(node.expanded);
    const { getLanguageAbbr } = useCookiesContext();
    const language = getLanguageAbbr();
    const { views } = topicClusterLabels[language];

    useEffect(() => {
        const expandListener = (event) => setExpanded(event.node.expanded);

        node.addEventListener("expandedChanged", expandListener);

        return () => {
        node.removeEventListener("expandedChanged", expandListener);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onClick = useCallback(() => node.setExpanded(!node.expanded), [node]);

    // inventory.name + '@' + views + '@' + inventory.inventory_hirarchy_level + '@' + getPath(inventories, item.inventory_id).length + '@' + min_bid + '@' + status,
    const [name, visits, , , min_bid, ] = value.split("@");
    // const allChildrenCount = node.allChildrenCount;
    const level = node.level + 1;


    return (
        <div 
            className="d-flex"
            style={{
                paddingLeft: `${node.level * 25 + 20}px`,
            }}
            onClick={onClick}
        >
            <div className="d-flex align-items-center" style={{ width: '20px', marginLeft: '-20px' }}>
                { node.group && (
                    <div
                        style={{
                            cursor: "pointer",
                            display: "inline-block",
                        }}
                    >
                        <span style={{ fontSize: "18px" }}>
                            <i class={expanded ? "ri-arrow-down-s-line text-secondary" : "ri-arrow-right-s-line text-secondary"}></i>
                        </span>
                    </div>
                )}
            </div>
            <div
                className='d-flex flex-column ms-1'
                // title={`Current invetory recived ${visits} visits per last 30 days`}
                >
                <small className='cluster-level-indicator me-1'>{level === 1 ? 'DC' : level === 2 ? 'C1' : 'C2'}</small>
            </div>
            <div
                className='d-flex flex-column ms-1'
                style={{ minWidth: 0, flex: 1 }}
            >
                <div className="table-item-name" style={{ minWidth: 0 }}>
                    <span style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "block",
                        width: "100%"
                    }}>
                        {name}
                    </span>
                </div>
                <div 
                    className="align-items-center text-secondary"
                    style={{ fontSize: '12px', marginTop: '-20px'}}
                >
                    {/* <span className='fw-bold'>Level {level} Topic {level === 1 ? 'Cluster' : 'Sub-Cluster'}</span>
                    { allChildrenCount > 0 && <span className=''>|</span> }
                    { allChildrenCount > 0 && <span className=''>{allChildrenCount} Topic Sub-Cluster{allChildrenCount > 1 ? 's' : ''}</span> } */}
                    {level === 1 ? (
                      <>
                        <span className='text-uppercase'>{topicClusterLabels[language]?.department}</span>
                        <span className=''> | </span>
                      </>
                    ) : (
                      <>
                        <span className='text-uppercase'>{topicClusterLabels[language]?.category}</span>
                        <span className=''> | </span>
                      </>
                    )}
                    {visits.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} {views}
                    <span className=''> | </span>
                    <span className=''>${min_bid}+</span>
                    {/* <span style={{marginLeft: '10px'}} className="text-warning"> 
                        <span className="badge-dot me-2 bg-warning"></span>
                        {status.toLowerCase()}
                    </span> */}
                </div>
            </div>
        </div>
    );
}

export function ClusterNameColumnHeaderTooltipRenderer() {
    const publisherIdByAbbr = getPubAbbr();
    const taxonomy = TaxonomyModule(publisherIdByAbbr);

    return taxonomy.tooltips.ppc_cluster_column_headers.topic;
}

export function ClusterNameCellTooltipRenderer({ value }) {
    const cookies = new Cookies();
    const pathKey = getPathKey();
    const language = cookies.get(pathKey)?.[cookiesKeyNames.language]?.value || "EN";

    const publisherIdByAbbr = getPubAbbr();
    const taxonomy = TaxonomyModule(publisherIdByAbbr);
    const visitsRaw = value.split("@")[1];
    const visits = visitsRaw?.trim() ?? "";
  
    // "Partner Management@0@2@2@6@Inherited@false".split("@")[6]
    const name = value.split("@")[0];
    const clusterLevel = value.split("@")[2];
    const isDirectory = value.split("@")[6] === "true";
    const minCpc = value.split("@")[4];

    // Department Cluster/Category Level 1 Cluster/Category Level 2 Cluster
    let clusterLevelText = topicClusterLabels[language]?.department;

    if (clusterLevel === "2") {
        clusterLevelText = topicClusterLabels[language]?.category + " C1";
    } else if (clusterLevel === "3") {
        clusterLevelText = topicClusterLabels[language]?.category + " C2";
    }

    return taxonomy.tooltips.ppc_cluster_column_inlines.topic[isDirectory ? "directory" : "non_directory"].replace("{views}", visits).replace("{inventory_name}", name).replace("{cluster_level}", clusterLevelText).replace("{min_cpc}", minCpc);
  }
 